import React from "react";
import "./Tips.css";

const Tips = () => {
  return (
    <div className="container pt-5 pb-5">
      <h2 className="text-center">MAKEUP ADVICE</h2>
      <div className="videos row">
        <div className="col-12 col-md-6 d-flex flex-column video mb-3">
          <h5 className="text-center fst-italic">
            Top 6 Must Have Nude Lipstick
          </h5>
          <hr />
          <div className="text-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/2O7dieLBxuQ"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex flex-column video mb-3">
          <h5 className="text-center fst-italic">Zanash Lipstick Swatch</h5>
          <hr />
          <div className="text-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/udVSXCX6rcw"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex flex-column video">
          <h5 className="text-center fst-italic">5 Lipstick Hacks</h5>
          <hr />
          <div className="text-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/SD25_d2DnlE"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="col-12 col-md-6 d-flex flex-column video">
          <h5 className="text-center fst-italic">Nior Lipstick Swatches</h5>
          <hr />
          <div className="text-center">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/9wM7D7j3yrw?start=5"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tips;
